import React, {Component} from 'react';
import { findDOMNode } from 'react-dom'
import {Box} from 'reactjs-admin-lte'
import {Button,ButtonToolbar,DropdownButton,SplitButton,MenuItem,ControlLabel,InputGroup,FormGroup,Row,Col,FormControl,Tabs,Tab} from 'react-bootstrap'
import Select from 'react-select';
import FontAwsome from 'react-fontawesome'
import { Checkbox, Radio } from 'react-icheck';
import WorkdocStore from '../../stores/WorkdocStore';
import './WorkDoc.css';

var NotificationSystem = require('react-notification-system');

class WorkDocTimeline extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      data:[],
      loading:true
    }
  }

  componentDidMount() {
  	let that = this
    WorkdocStore.loadTimeline(that.props.workNo,function(result) {
    	that.setState({data:result.data.timelinelist,loading:false})
    })
  }

  getDate(added_date) {
  	let year = added_date.substring(0, 4)
  	year = parseInt(year) + 543
  	let month = added_date.substring(5, 7)
  	let day = added_date.substring(8, 10)
  	let mText = ""
  	if (month=="01") {
  		mText = "ม.ค."
  	} else if (month=="02") {
  		mText = "ก.พ."
  	} else if (month=="03") {
  		mText = "มี.ค."
  	} else if (month=="04") {
  		mText = "เม.ย."
  	} else if (month=="05") {
  		mText = "พ.ค."
  	} else if (month=="06") {
  		mText = "มิ.ย."
  	} else if (month=="07") {
  		mText = "ก.ค."
  	} else if (month=="08") {
  		mText = "ส.ค."
  	} else if (month=="09") {
  		mText = "ก.ย."
  	} else if (month=="10") {
  		mText = "ต.ค."
  	} else if (month=="11") {
  		mText = "พ.ย."
  	} else if (month=="12") {
  		mText = "ธ.ค."
  	}
  	return day+" "+mText+" "+year
  }

  getDateBgColor(week_flag,today_flag) {
  	if (today_flag == 1)
        return "bg-green div-time-label";
    else if (week_flag == 1)
        return "bg-yellow div-time-label";
    else
        return "bg-red div-time-label";		
  }

  renderTimeline() {
  	let {data} = this.state
  	let check_date = ""
  	let display = "none"
  	return(
  		data.map((item,index) => {
  			if (check_date!=item.timeline_date) {
  				display = ""
  			} else {
  				display = "none"
  			}
  			check_date = item.timeline_date
  			return(
			    <li key={index}>       
			    	<div className="time-label" style={{marginBottom:'10px',display:display}}>
				    	<span className={this.getDateBgColor(item.week_flag,item.today_flag)}>
			                {this.getDate(item.added_date)}
			            </span>       
		            </div>              
			        <FontAwsome name='car' className='bg-blue' style={{position:'relative'}} />
			        <div className="timeline-item">
			            <span className="time"><FontAwsome name='clock-o' /> {item.timeline_time}</span>
			            <h3 className="timeline-header"><a href="#">{item.added_name}</a> {item.subject}</h3>
			            <div className="timeline-body">
							{item.message}                                    
						</div>
			            <div className="timeline-footer">
			                <a className="btn btn-primary btn-xs"><FontAwsome name='desktop' />&nbsp;IP : {item.ip_address}</a>
			            </div>                                    
			        </div>                                
			    </li>
			)    
	    })
  	)
  }

  render() {
  	return(
  		<div>
  			<Box loading={this.state.loading}>
  				<Box.Header>
  					<Box.Title>
  						<FontAwsome name="calendar-check-o" className="text-blue" />&nbsp;บันทึกเหตุการณ์
  					</Box.Title>
  				</Box.Header>
  				<Box.Body>
  					<Row>
  						<Col md={12}>
  							<ul className="timeline">
  								{this.renderTimeline()}
  								<li className="time-label">
		                            <span className="bg-green">
		                                เริ่มต้นงาน
		                            </span>
		                        </li>
		                        <li>
		                            <FontAwsome name='camera' className="bg-purple" />
		                            <div className="timeline-item">
		                                <span className="time"><FontAwsome name='clock-o' /> ...</span>
		                                <h3 className="timeline-header"><a href="#">CK-BOSS</a> ใบงาน {this.props.workNo}</h3>		                               
		                            </div>
		                        </li>
		                        <li>
		                            <FontAwsome name='clock-o' className="bg-gray" />
		                        </li>
  							</ul>	
  						</Col>
  					</Row>
  				</Box.Body>
  			</Box>
  		</div>
  	)
  }


}

export default WorkDocTimeline;


// WEBPACK FOOTER //
// ./src/view/workdoc/WorkDocTimeline.js